export default __webpack_public_path__ + "images/I5.bee356c.png";